import { BaseNomenclatorModel } from './base.model';

export class RawMaterialTypesModel extends BaseNomenclatorModel {
    name: string;
    code: string;
}
